module.exports = __webpack_public_path__ + "static/iso_16.7bef68d3.png";